<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
                 
            <vs-input class="inputx" placeholder="Barkod" @keyup.enter="stokListesi()"  :ref="barkod" v-model="barkod" />        </div>
      </vx-card>
      <br/>

    </div>
<div class="vx-col w-full mb-base">
    <vs-table :data="liste" >

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Stok Kodu</vs-th>
      <vs-th  sort-key="stokkodu">Barkod</vs-th>
      <vs-th>Stok Adı</vs-th>
      <vs-th>Gönderim Durumu</vs-th>
      <vs-th>Stok Adet</vs-th>
      <vs-th></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
 <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].stokKodu }}
        </vs-td>
        <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].Barkod }}
        </vs-td>
        <vs-td :data="data[indextr].partiNo">
          {{ data[indextr].StokAdi }}
        </vs-td>
      
        <vs-td :data="data[indextr].quantity">
          
           <span v-if="data[indextr].ticimaxGonderimDurumu==1" style="float:left" class="vx-col hidden lg:block lg:w-1/2"><img width="30" src="@/assets/images/pages/ticimax-logo.jpg" alt="login" class="mx-auto"></span>
           <span v-if="data[indextr].n11GonderimDurumu==1" style="float:left" class="vx-col hidden lg:block lg:w-1/2"><img width="30" src="@/assets/images/pages/n11-logo.jpg" alt="login" class="mx-auto"></span>
           <span v-if="data[indextr].trendyolGonderimDurumu==1" style="float:left" class="vx-col hidden lg:block lg:w-1/2"><img width="30" src="@/assets/images/pages/trendyol-logo.png" alt="login" class="mx-auto"></span>
           <span v-if="data[indextr].hepsiBuradaGonderimDurumu==1" style="float:left" class="vx-col hidden lg:block lg:w-1/2"><img width="30" src="@/assets/images/pages/hepsiburada-logo.png" alt="login" class="mx-auto"></span>
        </vs-td>
        <vs-td :data="data[indextr].quantity">
           {{ data[indextr].stokAdet }} 
        </vs-td>
        <vs-td>
        <vs-button @click="kartDetay(data[indextr].Barkod)" color="success" type="filled">Kart Detayı</vs-button>
        </vs-td>
      </vs-tr>
     
     
    </template>

  </vs-table>
</div>



  </div>



       
        <vs-popup fullscreen  class="holamundo" title="Kart Detayı" :active.sync="popupKartDetay">
         

         <template>
  <vs-tabs>
    <vs-tab label="Stok Kart Detayı" >
      <div class="con-tab-ejemplo">
        <table>
            <tr>
              <td>Stok Adı</td><td>{{ dStokAdi }}</td>
            </tr>
            <tr>
              <vs-td>Stok Kodu</vs-td>
              <vs-td>{{ dStokKodu }}</vs-td>
           </tr>
           <tr>
              <td>Barkod</td>
              <td>{{ dBarkod }}</td>
           </tr>
            <tr>
              <td>Ürün Kategorisi</td>
              <td>{{ dKategori }}</td>
           </tr>
            <tr>
              <td>Renk</td>
              <td>{{ dRenk }}</td>
           </tr>
           <tr>
              <td>Beden</td>
              <td>{{ dBeden }}</td>
            </tr>
            <tr>
              <td>Tanımlı Diğer Özellikler</td>
              <td>
                
                {{ dDigerOzellikler }}
                 
              </td>
                </tr>
              <tr>
              <td>Ürün Açıklaması</td>
              <td>
                
                <vs-textarea v-model="stokAciklama"/>
                 
              </td>
            </tr>
    

      </table>

      </div>
    </vs-tab>

     <vs-tab  label="Stok Resimleri" @click="resimListesi()">
      <div class="con-tab-ejemplo">
      <span>
        <table>
          <tr>
            <td>Resim Adı</td>
            <td><input type="text" v-model="resimAdi"></td>
            <td><vs-button @click="resimListeyeEkle()" type="filled">Resim Ekle</vs-button></td>
          </tr>
        </table>
        </span>
        
        
        <vs-table :data="stokResimListesi">
        <template slot="thead">
          
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Barkod</vs-th>
          <vs-th>Resim Adı</vs-th>
          <vs-th>Sil</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].stokKodu }}
              </vs-td>
              <vs-td>
               {{ data[indextr].barkod }}
              </vs-td>
              <vs-td>
               {{ data[indextr].resimAdi }}
              </vs-td>
              <vs-td>
                <vs-button @click="resimSil(data[indextr].id)" type="filled" color="red">Resim Sil</vs-button>
              </vs-td>
            
            </vs-tr>
          </template>

      </vs-table>
      
      </div>
    </vs-tab>

    <vs-tab @click="pazaryeriDetay('Trendyol')" label="Trendyol">
      <div class="con-tab-ejemplo">
      <span>

        <table>
          <tr>
            
            <td colspan="2" style="color:red">
                {{trendyolBilgilendirme}}
            </td>
          </tr>
          <tr>
            <td>
              Kateogrisi
            </td>
            <td>
                {{trendyolKategori}}
            </td>
          </tr>
          <tr>
            <td>
              Satış Fiyatı
            </td>
            <td>
              <input type="text" v-model="trendyolSatisFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Piyasa Fiyatı
            </td>
            <td>
              <input type="text" v-model="trendyolPiyasaFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Gönderilecek Adet
            </td>
            <td>
              <input type="text" v-model="trendyolGonderilecekAdet">
            </td>
          </tr>

          <tr :hidden="validatedAlan1">
            <td>
              {{alan1Ad}}
            </td>
            <td>
              {{alan1Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan2">
            <td>
              {{alan2Ad}}
            </td>
            <td>
              {{alan2Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan3">
            <td>
              {{alan3Ad}}
            </td>
            <td>
              {{alan3Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan4">
            <td>
              {{alan4Ad}}
            </td>
            <td>
              {{alan4Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan5">
            <td>
              {{alan5Ad}}
            </td>
            <td>
              {{alan5Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan6">
            <td>
              {{alan6Ad}}
            </td>
            <td>
              {{alan6Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan7">
            <td>
              {{alan7Ad}}
            </td>
            <td>
              {{alan7Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan8">
            <td>
              {{alan8Ad}}
            </td>
            <td>
              {{alan8Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan9">
            <td>
              {{alan9Ad}}
            </td>
            <td>
              {{alan9Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan10">
            <td>
              {{alan10Ad}}
            </td>
            <td>
              {{alan10Deger}}
            </td>
          </tr>

          <tr>
            <td>
             
             <vs-button @click="gonderimListesineEkle('Trendyol')" color="success" type="filled"  :id="'b_1'" class="vs-con-loading__container">Listeye Ekle</vs-button>
            </td>
            <td>
              <vs-button @click="trendyolGonder()" type="filled" >Trendyola Gönder</vs-button>
            </td>
          </tr>

          </table>  
        

        <vs-table :data="gonderilenStokListesi">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>


      </span>
        </div>
    </vs-tab>

    <vs-tab @click="pazaryeriDetay('N11')" label="N11">
      <div class="con-tab-ejemplo">
      <span>
        
        <table>
          <tr>
            
            <td colspan="2" style="color:red">
                {{n11Bilgilendirme}}
            </td>
          </tr>
          <tr>
            <td>
              Kateogrisi
            </td>
            <td>
                {{n11Kategori}}
            </td>
          </tr>
          <tr>
            <td>
              Satış Fiyatı
            </td>
            <td>
              <input type="text" v-model="n11SatisFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Piyasa Fiyatı
            </td>
            <td>
              <input type="text" v-model="n11PiyasaFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Gönderilecek Adet
            </td>
            <td>
              <input type="text" v-model="n11GonderilecekAdet">
            </td>
          </tr>

          <tr :hidden="validatedAlan1">
            <td>
              {{alan1Ad}}
            </td>
            <td>
              {{alan1Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan2">
            <td>
              {{alan2Ad}}
            </td>
            <td>
              {{alan2Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan3">
            <td>
              {{alan3Ad}}
            </td>
            <td>
              {{alan3Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan4">
            <td>
              {{alan4Ad}}
            </td>
            <td>
              {{alan4Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan5">
            <td>
              {{alan5Ad}}
            </td>
            <td>
              {{alan5Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan6">
            <td>
              {{alan6Ad}}
            </td>
            <td>
              {{alan6Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan7">
            <td>
              {{alan7Ad}}
            </td>
            <td>
              {{alan7Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan8">
            <td>
              {{alan8Ad}}
            </td>
            <td>
              {{alan8Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan9">
            <td>
              {{alan9Ad}}
            </td>
            <td>
              {{alan9Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan10">
            <td>
              {{alan10Ad}}
            </td>
            <td>
              {{alan10Deger}}
            </td>
          </tr>

          <tr>
            <td>
             <vs-button @click="gonderimListesineEkle('N11')" color="success" type="filled"  :id="'b_2'" class="vs-con-loading__container">Listeye Ekle</vs-button>
            </td>
            <td>
              <vs-button @click="n11Gonder()" type="filled" >N11 Gönder</vs-button>
            </td>
          </tr>

          </table>  
        

        <vs-table :data="gonderilenStokListesiN11">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>
        
        
        
        </span></div>
    </vs-tab>

    <vs-tab  @click="pazaryeriDetay('Hepsiburada')" label="Hepsiburada">
      <div class="con-tab-ejemplo">
      <span>
        
        <table>
          <tr>
            
            <td colspan="2" style="color:red">
                {{hepsiburadaBilgilendirme}}
            </td>
          </tr>
          <tr>
            <td>
              Kateogrisi
            </td>
            <td>
                {{hepsiburadaKategori}}
            </td>
          </tr>
          <tr>
            <td>
              Satış Fiyatı
            </td>
            <td>
              <input type="text" v-model="hepsiburadaSatisFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Piyasa Fiyatı
            </td>
            <td>
              <input type="text" v-model="hepsiburadaPiyasaFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Gönderilecek Adet
            </td>
            <td>
              <input type="text" v-model="hepsiburadaGonderilecekAdet">
            </td>
          </tr>

          <tr :hidden="validatedAlan1">
            <td>
              {{alan1Ad}}
            </td>
            <td>
              {{alan1Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan2">
            <td>
              {{alan2Ad}}
            </td>
            <td>
              {{alan2Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan3">
            <td>
              {{alan3Ad}}
            </td>
            <td>
              {{alan3Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan4">
            <td>
              {{alan4Ad}}
            </td>
            <td>
              {{alan4Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan5">
            <td>
              {{alan5Ad}}
            </td>
            <td>
              {{alan5Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan6">
            <td>
              {{alan6Ad}}
            </td>
            <td>
              {{alan6Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan7">
            <td>
              {{alan7Ad}}
            </td>
            <td>
              {{alan7Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan8">
            <td>
              {{alan8Ad}}
            </td>
            <td>
              {{alan8Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan9">
            <td>
              {{alan9Ad}}
            </td>
            <td>
              {{alan9Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan10">
            <td>
              {{alan10Ad}}
            </td>
            <td>
              {{alan10Deger}}
            </td>
          </tr>

          <tr>
            <td>
             <vs-button @click="gonderimListesineEkle('Hepsiburada')" color="success" type="filled"  :id="'b_3'" class="vs-con-loading__container">Listeye Ekle</vs-button>
            </td>
            <td>
              <vs-button @click="hepsiburadaGonder()" type="filled" >Hepsiburada Gönder</vs-button>
            </td>
          </tr>

          </table>  
        

        <vs-table :data="gonderilenStokListesiHepsiburada">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>
        
        
        
        </span></div>
    </vs-tab>
    <vs-tab  @click="pazaryeriDetay('Ticimax')" label="Ticimax">
      <div class="con-tab-ejemplo">
      <span>
        
        <table>
          <tr>
            
            <td colspan="2" style="color:red">
                {{ticimaxBilgilendirme}}
            </td>
          </tr>
          <tr>
            <td>
              Kateogrisi
            </td>
            <td>
                {{ticimaxKategori}}
            </td>
          </tr>
          <tr>
            <td>
              Satış Fiyatı
            </td>
            <td>
              <input type="text" v-model="ticimaxSatisFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Piyasa Fiyatı
            </td>
            <td>
              <input type="text" v-model="ticimaxPiyasaFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Gönderilecek Adet
            </td>
            <td>
              <input type="text" v-model="ticimaxGonderilecekAdet">
            </td>
          </tr>

          <tr :hidden="validatedAlan1">
            <td>
              {{alan1Ad}}
            </td>
            <td>
              {{alan1Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan2">
            <td>
              {{alan2Ad}}
            </td>
            <td>
              {{alan2Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan3">
            <td>
              {{alan3Ad}}
            </td>
            <td>
              {{alan3Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan4">
            <td>
              {{alan4Ad}}
            </td>
            <td>
              {{alan4Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan5">
            <td>
              {{alan5Ad}}
            </td>
            <td>
              {{alan5Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan6">
            <td>
              {{alan6Ad}}
            </td>
            <td>
              {{alan6Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan7">
            <td>
              {{alan7Ad}}
            </td>
            <td>
              {{alan7Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan8">
            <td>
              {{alan8Ad}}
            </td>
            <td>
              {{alan8Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan9">
            <td>
              {{alan9Ad}}
            </td>
            <td>
              {{alan9Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan10">
            <td>
              {{alan10Ad}}
            </td>
            <td>
              {{alan10Deger}}
            </td>
          </tr>

          <tr>
            <td>
             <vs-button @click="gonderimListesineEkle('Ticimax')" color="success" type="filled"  :id="'b_4'" class="vs-con-loading__container">Listeye Ekle</vs-button>
            </td>
            <td><vs-button @click="ticimaxGonder()" color="red" type="filled">Ticimax Gönder</vs-button></td>
          </tr>

          </table>  
        

        <vs-table :data="gonderilenStokListesiHepsiburada">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>
        
        
        
        </span></div>
    </vs-tab>
   <vs-tab  @click="pazaryeriDetay('Pazarama')" label="Pazarama">
      <div class="con-tab-ejemplo">
      <span>
        
        <table>
          <tr>
            
            <td colspan="2" style="color:red">
                {{pazaramaBilgilendirme}}
            </td>
          </tr>
          <tr>
            <td>
              Kateogrisi
            </td>
            <td>
                {{pazaramaKategori}}
            </td>
          </tr>
          <tr>
            <td>
              Satış Fiyatı
            </td>
            <td>
              <input type="text" v-model="pazaramaSatisFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Piyasa Fiyatı
            </td>
            <td>
              <input type="text" v-model="pazaramaPiyasaFiyati">
            </td>
          </tr>
          <tr>
            <td>
              Gönderilecek Adet
            </td>
            <td>
              <input type="text" v-model="pazaramaGonderilecekAdet">
            </td>
          </tr>

          <tr :hidden="validatedAlan1">
            <td>
              {{alan1Ad}}
            </td>
            <td>
              {{alan1Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan2">
            <td>
              {{alan2Ad}}
            </td>
            <td>
              {{alan2Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan3">
            <td>
              {{alan3Ad}}
            </td>
            <td>
              {{alan3Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan4">
            <td>
              {{alan4Ad}}
            </td>
            <td>
              {{alan4Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan5">
            <td>
              {{alan5Ad}}
            </td>
            <td>
              {{alan5Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan6">
            <td>
              {{alan6Ad}}
            </td>
            <td>
              {{alan6Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan7">
            <td>
              {{alan7Ad}}
            </td>
            <td>
              {{alan7Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan8">
            <td>
              {{alan8Ad}}
            </td>
            <td>
              {{alan8Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan9">
            <td>
              {{alan9Ad}}
            </td>
            <td>
              {{alan9Deger}}
            </td>
          </tr>

          <tr :hidden="validatedAlan10">
            <td>
              {{alan10Ad}}
            </td>
            <td>
              {{alan10Deger}}
            </td>
          </tr>

          <tr>
            <td>
             <vs-button @click="gonderimListesineEkle('Pazarama')" color="success" type="filled"  :id="'b_5'" class="vs-con-loading__container">Listeye Ekle</vs-button>
            </td>
            <td>
              <vs-button @click="pazaramaGonder()" type="filled" >Pazarama Gönder</vs-button>
            </td>
          </tr>

          </table>  
        

        <vs-table :data="gonderilenStokListesiHepsiburada">
        <template slot="thead">
          
          <vs-th>Barkod</vs-th>
          <vs-th>Durum</vs-th>
          <vs-th>Alınan Hata</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].barcode }}
              </vs-td>
              <vs-td>
               {{ data[indextr].status }}
              </vs-td>
              <vs-td>
               {{ data[indextr].failureReasons }}
              </vs-td>
           
            
            </vs-tr>
          </template>

      </vs-table>
        
        
        
        </span></div>
    </vs-tab>
    
  </vs-tabs>
</template>


        


        </vs-popup>


    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      liste:[],
      gonderilenStokListesi:[],
      gonderilenStokListesiN11:[],
      gonderilenStokListesiHepsiburada:[],
      gonderilenStokListesiTicimax:[],
      stokResimListesi:[],
      kod:'',
      barkod:'',
      popupKartDetay:false,
      dStokAdi:'',
      dStokKodu:'',
      dBarkod:'',
      dRenk:'',
      dBeden:'',
      dDigerOzellikler:'',
      dKategori:'',
      dSatisFiyat:0,
      dPiyasaFiyat:0,
      dStokAdet:0,
      dKdv:0,
      trendyolKategori:'',
      trendyolKategoriId:0,
      trendyolSatisFiyati:0,
      trendyolPiyasaFiyati:0,
      trendyolGonderilecekAdet:0,
      trendyolBilgilendirme:'',
      n11Kategori:'',
      n11KategoriId:0,
      n11SatisFiyati:0,
      n11PiyasaFiyati:0,
      n11GonderilecekAdet:0,
      n11Bilgilendirme:'',
      hepsiburadaKategori:'',
      hepsiburadaKategoriId:0,
      hepsiburadaSatisFiyati:0,
      hepsiburadaPiyasaFiyati:0,
      hepsiburadaGonderilecekAdet:0,
      hepsiburadaBilgilendirme:'',

      pazaramaKategori:'',
      pazaramaKategoriId:0,
      pazaramaSatisFiyati:0,
      pazaramaPiyasaFiyati:0,
      pazaramaGonderilecekAdet:0,
      pazaramaBilgilendirme:'',


      ticimaxKategori:'',
      ticimaxKategoriId:0,
      ticimaxSatisFiyati:0,
      ticimaxPiyasaFiyati:0,
      ticimaxGonderilecekAdet:0,
      ticimaxBilgilendirme:'',
      ticimaxMarkaId:'',
      hepsiBuradaMarka:'',
      alan1:'',
      alan2:'',
      alan3:'',
      alan4:'',
      alan5:'',
      alan6:'',
      alan7:'',
      alan8:'',
      alan9:'',
      alan10:'',
      validatedAlan1:true,
      validatedAlan2:true,
      validatedAlan3:true,
      validatedAlan4:true,
      validatedAlan5:true,
      validatedAlan6:true,
      validatedAlan7:true,
      validatedAlan8:true,
      validatedAlan9:true,
      validatedAlan10:true,
      alan1Ad:'',
      alan2Ad:'',
      alan3Ad:'',
      alan4Ad:'',
      alan5Ad:'',
      alan6Ad:'',
      alan7Ad:'',
      alan8Ad:'',
      alan9Ad:'',
      alan10Ad:'',
      alan1Deger:'',
      alan2Deger:'',
      alan3Deger:'',
      alan4Deger:'',
      alan5Deger:'',
      alan6Deger:'',
      alan7Deger:'',
      alan8Deger:'',
      alan9Deger:'',
      alan10Deger:'',
      validateTrendyolListeyeEkle:true,
      validateTrendyolGonder:true,
      validateN11ListeyeEkle:true,
      validateN11Gonder:true,
      validateHepsiburadaListeyeEkle:true,
      validateHepsiburadaGonder:true,
      validatepazaramaListeyeEkle:true,
      validatepazaramaGonder:true,
      validateTicimaxListeyeEkle:true,
      validateTicimaxGonder:true,
      stokAciklama:'',
      resimAdi:'',
    }
  },methods: {
    resimSil(resimId) {
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,resimId:resimId}
      soap.createClient(url, function(err, client){
      client.stokResimSil(args, function(err, result){
        if (result.stokResimEkleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //vm.veriler=JSON.parse(result.StokAktarResult)
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       vm.resimListesi()
        
      })
      })
    },
    resimListeyeEkle(){
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)
      
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,stokKodu:this.dStokKodu,barkod:this.dBarkod,resimAdi:this.resimAdi}
      soap.createClient(url, function(err, client){
      client.stokResimEkle(args, function(err, result){
        if (result.stokResimEkleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //vm.veriler=JSON.parse(result.StokAktarResult)
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       vm.resimListesi()
        
      })
      })

    },
    resimListesi(){
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)
      
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,stokKodu:this.dStokKodu,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.stokResimListesi(args, function(err, result){
        if (result.stokResimListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //console.log(result.stokResimListesiResult)
        vm.veriler=JSON.parse(result.stokResimListesiResult)
        vm.stokResimListesi=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       
        
      })
      })

    },
    hepsiburadaGonder() {

           // this.popupGonderilenStokListesi=true
         var vm = this
var vs = this.$vs
    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Hepsiburada',token:Store.state.tokenId,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.StokAktar(args, function(err, result){
        if (result.StokAktarResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        console.log(result.StokAktarResult)
       var sonuc=result.StokAktarResult
       
     //  const userStr = JSON.stringify(sonuc);
        vm.veriler=JSON.parse(sonuc)
       // const d=JSON.parse(vm.veriler)
   // console.log(vm.veriler)
   if (vm.veriler.error=='Yes') {
        vs.notify({
            title: 'Hepsiburada Gönderim Hatası',
            text: vm.veriler.mesaj,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
   } else {
   if (vm.veriler.json[0].status=='SUCCESS') {
     vm.mesajHB=vm.veriler.json[0].importMessages.split('&');
     vm.hepsiburadaGonderimHatasi=vm.mesajHB[1]+'eksikler'
     console.log(vm.mesajHB[1])
       vs.notify({
            title: 'Hepsiburada',
            text: "Hepsiburada Gönderim Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
   } else {
     // console.log(vm.veriler)
      vm.mesajHB=vm.veriler.json[0].importMessages.split('&');
     vm.hepsiburadaGonderimHatasi=vm.mesajHB[1]
       vs.notify({

            title: 'Hepsiburada Gönderim Hatalı',
            text: vm.mesajHB[0],
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
   }
   }
    /*console.log(vm.veriler.batchRequestId)
    console.log(vm.veriler['batchRequestId'])
    console.log(d.batchRequestId)
    console.log(d['batchRequestId'])
    const batch=d['batchRequestId']*/
    /*if (typeof batch!='undefined') {
     batch =d.batchRequestId
    }*/

   //console.log(batch)
   /* if (typeof batch!='undefined') {
      vm.trendyolAktarumDurum(d['batchRequestId'])
    } else {

      vs.notify({
            title: 'Trendyol Gönderim Hatalı',
            text: d.errors[0].message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
        vm.trendyolDurumMesaji=d.errors[0].message
    }**/
    


        //console.log(vm.veriler.timestamp)
        //let k=vm.veriler


        /*if (k.hasOwnProperty('batchRequestId')) {
            
        } else {
          console.log(k.timestamp)
        }*/
       // vm.eslesenStokListesi=vm.veriler
       // console.log(vm.veriler.batchRequestId)
       // vm.gonderilenStokListesi=vm.veriler
         setTimeout(function() {
         //vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  

       
        
      })
      })


    },
    trendyolGonder() {

                  this.popupGonderilenStokListesi=true
         var vm = this
var vs = this.$vs
    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Trendyol',token:Store.state.tokenId,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.StokAktar(args, function(err, result){
        if (result.StokAktarResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
       // console.log(result.StokAktarResult)
       var sonuc=result.StokAktarResult
       
     //  const userStr = JSON.stringify(sonuc);
        vm.veriler=JSON.parse(sonuc)
        const d=JSON.parse(vm.veriler)
    console.log(vm.veriler)
    console.log(vm.veriler.batchRequestId)
    console.log(vm.veriler['batchRequestId'])
    console.log(d.batchRequestId)
    console.log(d['batchRequestId'])
    let batch=d['batchRequestId']
    /*if (typeof batch!='undefined') {
     batch =d.batchRequestId
    }*/

   console.log(batch)
    if (typeof batch!='undefined') {
       setTimeout(function() {
          vm.trendyolAktarumDurum(batch)
    }, 2500)
     
    } else {

      vs.notify({
            title: 'Trendyol Gönderim Hatalı',
            text: d.errors[0].message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
        vm.trendyolDurumMesaji=d.errors[0].message
    }
    


        //console.log(vm.veriler.timestamp)
        //let k=vm.veriler


        /*if (k.hasOwnProperty('batchRequestId')) {
            
        } else {
          console.log(k.timestamp)
        }*/
       // vm.eslesenStokListesi=vm.veriler
       // console.log(vm.veriler.batchRequestId)
       // vm.gonderilenStokListesi=vm.veriler
         setTimeout(function() {
         //vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  

       
        
      })
      })



    },
    trendyolAktarumDurum(kod) {
var vm = this
           const soap = require('soap')
      const url = state.sistemAddress


       const args={program:'Trendyol',durumKodu:kod}
        soap.createClient(url, function(err, client){
      client.aktarimDurumSorgula(args, function(err, result){
       // console.log(result1.aktarimDurumSorgulaResult)
        vm.veriler=JSON.parse(result.aktarimDurumSorgulaResult)
        console.log(vm.veriler)
        vm.gonderilenStokListesi=vm.veriler
      // console.log(vm.veriler)
        
      })
        })

    },
    n11Gonder() {
var vs = this.$vs
            this.popupGonderilenStokListesi=true
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'N11',token:Store.state.tokenId,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.StokAktar(args, function(err, result){
        if (result.StokAktarResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      //  console.log(result.StokAktarResult)
        vm.veriler=JSON.parse(result.StokAktarResult)
       if (vm.veriler.response=="No") {
           vs.notify({
            title: 'N11 Gönderim Hatalı',
            text: vm.veriler.mesaj,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
       }
       // vm.eslesenStokListesi=vm.veriler
        //console.log(vm.veriler)
        
         /*setTimeout(function() {
         vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  */

       
        
      })
      })


    },
    gonderimListesineEkle(pazaryeri) {
     
//console.log(pazaryeri+' ** '+Store.state.tokenId+' ** '+pazaryeri+' ** '+this.dStokKodu+' ** '+1+' ** '+this.dBarkod+' ** '+this.trendyolGonderilecekAdet+' ** '+this.alan1+' ** '+ this.alan2+' ** '+ this.alan3+' ** '+ this.alan4+' ** '+ this.alan5+' ** '+ this.alan6+' ** '+ this.alan7+' ** '+ this.alan8+' ** '+this.alan9+' ** '+this.alan10+' ** '+ this.dRenk+' ** '+this.dBeden+' ** '+this.trendyolSatisFiyati+' ** '+this.trendyolGonderilecekAdet+' ** '+this.trendyolSatisFiyati+' ** '+this.trendyolPiyasaFiyati+' ** '+this.trendyolKategoriId)
var vs = this.$vs
     

      var vm = this

    const soap = require('soap')
    let args;
      const url = state.sistemAddress
      let btnLnk="";
     switch (pazaryeri) {
       case 'Trendyol': 
       btnLnk="b_1";
         args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.trendyolGonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.trendyolSatisFiyati, adet:this.trendyolGonderilecekAdet, gonderilecekFiyat:this.trendyolSatisFiyati, gonderilecekPiyasaFiyati:this.trendyolPiyasaFiyati, pazaryeriId:this.trendyolKategoriId,detay:this.stokAciklama,kdv:this.dKdv}
       break;
       case 'N11':
         btnLnk="b_2";
          args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.n11GonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.n11SatisFiyati, adet:this.n11GonderilecekAdet, gonderilecekFiyat:this.n11SatisFiyati, gonderilecekPiyasaFiyati:this.n11PiyasaFiyati, pazaryeriId:this.n11KategoriId,detay:this.stokAciklama,kdv:this.dKdv}
         break;
          case 'Hepsiburada':
          btnLnk="b_3";
          args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.hepsiburadaGonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.hepsiburadaSatisFiyati, adet:this.hepsiburadaGonderilecekAdet, gonderilecekFiyat:this.hepsiburadaSatisFiyati, gonderilecekPiyasaFiyati:this.hepsiburadaPiyasaFiyati, pazaryeriId:this.hepsiburadaKategoriId,detay:this.stokAciklama,kdv:this.dKdv,ticimaxMarkaId:this.hepsiBuradaMarka}
         break;
         case 'Ticimax':
           btnLnk="b_4";
          args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.ticimaxGonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.ticimaxSatisFiyati, adet:this.ticimaxGonderilecekAdet, gonderilecekFiyat:this.ticimaxSatisFiyati, gonderilecekPiyasaFiyati:this.ticimaxPiyasaFiyati, pazaryeriId:this.ticimaxKategoriId,detay:this.stokAciklama,kdv:this.dKdv,ticimaxMarkaId:this.ticimaxMarkaId}
         break;
          case 'Pazarama':
           btnLnk="b_5";
          args = {token:Store.state.tokenId,program:pazaryeri,stokKodu:this.dStokKodu,stokAdi:this.dStokAdi,durum:1,barkod:this.dBarkod,gonderilecekAdet:this.pazaramaGonderilecekAdet,alan1:this.alan1, alan2:this.alan2,alan3:this.alan3,  alan4:this.alan4, alan5:this.alan5, alan6:this.alan6, alan7:this.alan7, alan8:this.alan8, alan9:this.alan9,  alan10:this.alan10, renk:this.dRenk, beden:this.dBeden, fiyat:this.pazaramaSatisFiyati, adet:this.pazaramaGonderilecekAdet, gonderilecekFiyat:this.pazaramaSatisFiyati, gonderilecekPiyasaFiyati:this.pazaramaPiyasaFiyati, pazaryeriId:this.pazaramaKategoriId,detay:this.stokAciklama,kdv:this.dKdv,ticimaxMarkaId:this.pazaramaMarkaId}
         break;

     }
      console.log(args)
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#"+btnLnk,
        scale: 0.45
      })

      console.log(url)
      soap.createClient(url, function(err, client){
      client.gonderimListesineEkle(args, function(err, result){
        if (result.gonderimListesineEkleResult=='-1') {
          Store.dispatch('logout')
          
        }
      console.log(result.gonderimListesineEkleResult)
    
       vs.loading.close("#"+btnLnk+" > .con-vs-loading")
      
       
      })
      })
    },
    resimYukle(resimler,sayi,id,pazaryeri) {
      var vs = this.$vs
      const tumResimler=JSON.parse(resimler)
      const resimSayisi=tumResimler.length
      var vm = this
     // console.log(tumResimler[sayi]['resim'])
      if (resimSayisi>0) {
          const f = tumResimler[sayi]['resim'].split("\\")
          const t=f.length
          const t1=t-1
         /// console.log(f[t1])
         const soap = require('soap')
      const url = state.sistemAddress
           const args1 = {resimYolu:tumResimler[sayi]['resim'],resimAdi:f[t1]}
           soap.createClient(url, function(err, client){
           client.ftpResimYukle(args1, function(erri,result){
             console.log(result.ftpResimYukleResult)
             if (result.ftpResimYukleResult=="Ok") {
              // alert("burda")
               sayi=sayi+1
               if (sayi<resimSayisi) {
                 vm.resimYukle(resimler,sayi,id)
               } else {
                 //alert("bitti")
                  vs.loading.close("#b_1 > .con-vs-loading")
                  document.getElementById("b_1").disabled=true
                  switch (pazaryeri) {
                    case 'Trendyol': vm.validateTrendyolGonder=false; break; 
                    case 'N11': vm.validateN11Gonder=false; break; 
                    case 'Hepsiburada': vm.validateHepsiburadaGonder=false; break; 
                    case 'Ticimax': vm.validateTicimaxGonder=false; break; 
                  }
                  
               }
             }
           })
           })
      } else {

        switch (pazaryeri) {
                    case 'Trendyol': 
                    vs.loading.close("#b_1 > .con-vs-loading");
                  document.getElementById("b_1").disabled=true;
                  vm.validateTrendyolGonder=false;
                    break; 
                    case 'N11': 
                    vs.loading.close("#b_2 > .con-vs-loading");
                  document.getElementById("b_2").disabled=true;
                  vm.validateN11Gonder=false;
                    break; 
                    case 'Hepsiburada': 
                    vs.loading.close("#b_3 > .con-vs-loading");
                  document.getElementById("b_3").disabled=true;
                  vm.validateHepsiburadaGonder=false;
                    break; 
                    case 'Ticimax': 
                    vs.loading.close("#b_4 > .con-vs-loading");
                  document.getElementById("b_4").disabled=true;
                  vm.validateTicimaxListeyeEkle=false;
                    break; 
                    case 'Pazarama': 
                    vs.loading.close("#b_4 > .con-vs-loading");
                  document.getElementById("b_4").disabled=true;
                  vm.validateHepsiburadaGonder=false;
                    break; 
                  }


                  
      }
    },
    pazaryeriDetay(pazaryeri) {
     this.gonderilenStokListesi=[]
     this.gonderilenStokListesiN11=[]
     this.gonderilenStokListesiHepsiburada=[]
     this.gonderilenStokListesiTicimax=[]
      this.validateTrendyolListeyeEkle=true
      this.validateTrendyolGonder=true
      this.validateN11ListeyeEkle=true
      this.validateN11Gonder=true
      this.validateHepsiburadaListeyeEkle=true
      this.validateHepsiburadaGonder=true
      this.validateTicimaxListeyeEkle=true
      this.validateTicimaxGonder=true
       var vm = this
      const soap = require('soap')
      const url = state.sistemAddress
     // console.log(Store.state.tokenId+' , '+pazaryeri+' , '+vm.dBarkod)
      const args = {token:Store.state.tokenId,pazaryeri:pazaryeri,barkod:vm.dBarkod}
      soap.createClient(url, function(err, client){
      client.stokPazaryeriDetay(args, function(err, result){
        if (result.stokPazaryeriDetayResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        vm.veriler=''
         vm.veriler=JSON.parse(result.stokPazaryeriDetayResult)
         console.log(result.stokPazaryeriDetayResult)
         if (vm.veriler[0].error=="No") {
          switch (pazaryeri) {
            case 'Trendyol': 
            vm.trendyolKategori=vm.veriler[0].pazaryeriKategori
            vm.trendyolKategoriId=vm.veriler[0].pazaryeriId
            vm.trendyolSatisFiyati=vm.veriler[0].guncelStokFiyat
            vm.trendyolPiyasaFiyati=vm.veriler[0].guncelPiyasaFiyat
            vm.trendyolGonderilecekAdet=vm.veriler[0].gonderilecekAdet
            vm.alan1=vm.veriler[0].alan1
            vm.alan2=vm.veriler[0].alan2
            vm.alan3=vm.veriler[0].alan3
            vm.alan4=vm.veriler[0].alan4
            vm.alan5=vm.veriler[0].alan5
            vm.alan6=vm.veriler[0].alan6
            vm.alan7=vm.veriler[0].alan7
            vm.alan8=vm.veriler[0].alan8
            vm.alan9=vm.veriler[0].alan9
            vm.alan10=vm.veriler[0].alan10

            vm.trendyolBilgilendirme=''
            switch (vm.veriler[0].durum) {
              case '0': 
                vm.validateTrendyolListeyeEkle=false
                vm.validateTrendyolGonder=true
              break;
              case '1': 
                vm.validateTrendyolListeyeEkle=true
                vm.validateTrendyolGonder=false
              break;
              case '2': 
                vm.validateTrendyolListeyeEkle=true
                vm.validateTrendyolGonder=true
              break;
            }

            if (vm.trendyolSatisFiyati=='0') {
              vm.trendyolSatisFiyati=vm.dSatisFiyat;
              vm.trendyolBilgilendirme='Dikkat! Aşağıdaki alanlar stok kartında getirildi'
            }
            if (vm.trendyolKategoriId=="") {
              vm.trendyolBilgilendirme='Dikkat! Eşleşen Kategori Yok'
              vm.validateTrendyolListeyeEkle=true
              vm.validateTrendyolGonder=true
            }
            if (vm.trendyolPiyasaFiyati=='0') {
              vm.trendyolPiyasaFiyati=vm.dPiyasaFiyat;
             
            }
            if (vm.trendyolGonderilecekAdet=='0') {
              vm.trendyolGonderilecekAdet=vm.dStokAdet;
              
            }
            
            if (vm.veriler[0].alan1!='') {
              vm.validatedAlan1=false
              const ayir=vm.veriler[0].alan1.split('*')
              vm.alan1Ad=ayir[0]
              vm.alan1Deger=ayir[1]
            }

            if (vm.veriler[0].alan2!='') {
              vm.validatedAlan2=false
              const ayir=vm.veriler[0].alan2.split('*')
              vm.alan2Ad=ayir[0]
              vm.alan2Deger=ayir[1]
            }

            if (vm.veriler[0].alan3!='') {
              vm.validatedAlan3=false
              const ayir=vm.veriler[0].alan3.split('*')
              vm.alan3Ad=ayir[0]
              vm.alan3Deger=ayir[1]
            }

            if (vm.veriler[0].alan4!='') {
              vm.validatedAlan4=false
              const ayir=vm.veriler[0].alan4.split('*')
              vm.alan4Ad=ayir[0]
              vm.alan4Deger=ayir[1]
            }

            if (vm.veriler[0].alan5!='') {
              vm.validatedAlan5=false
              const ayir=vm.veriler[0].alan5.split('*')
              vm.alan5Ad=ayir[0]
              vm.alan5Deger=ayir[1]
            }

            if (vm.veriler[0].alan6!='') {
              vm.validatedAlan6=false
              const ayir=vm.veriler[0].alan6.split('*')
              vm.alan6Ad=ayir[0]
              vm.alan6Deger=ayir[1]
            }

            if (vm.veriler[0].alan7!='') {
              vm.validatedAlan7=false
              const ayir=vm.veriler[0].alan7.split('*')
              vm.alan7Ad=ayir[0]
              vm.alan7Deger=ayir[1]
            }

            if (vm.veriler[0].alan8!='') {
              vm.validatedAlan8=false
              const ayir=vm.veriler[0].alan8.split('*')
              vm.alan8Ad=ayir[0]
              vm.alan8Deger=ayir[1]
            }

            if (vm.veriler[0].alan9!='') {
              vm.validatedAlan9=false
              const ayir=vm.veriler[0].alan9.split('*')
              vm.alan9Ad=ayir[0]
              vm.alan9Deger=ayir[1]
            }

            if (vm.veriler[0].alan10!='') {
              vm.validatedAlan10=false
              const ayir=vm.veriler[0].alan10.split('*')
              vm.alan10Ad=ayir[0]
              vm.alan10Deger=ayir[1]
            }
            break;

            case 'N11': 
            vm.n11Kategori=vm.veriler[0].pazaryeriKategori
            vm.n11KategoriId=vm.veriler[0].pazaryeriId
            vm.n11SatisFiyati=vm.veriler[0].guncelStokFiyat
            vm.n11PiyasaFiyati=vm.veriler[0].guncelPiyasaFiyat
            vm.n11GonderilecekAdet=vm.veriler[0].gonderilecekAdet
            vm.alan1=vm.veriler[0].alan1
            vm.alan2=vm.veriler[0].alan2
            vm.alan3=vm.veriler[0].alan3
            vm.alan4=vm.veriler[0].alan4
            vm.alan5=vm.veriler[0].alan5
            vm.alan6=vm.veriler[0].alan6
            vm.alan7=vm.veriler[0].alan7
            vm.alan8=vm.veriler[0].alan8
            vm.alan9=vm.veriler[0].alan9
            vm.alan10=vm.veriler[0].alan10

            vm.n11Bilgilendirme=''
            switch (vm.veriler[0].durum) {
              case '0': 
                vm.validateN11ListeyeEkle=false
                vm.validateN11Gonder=true
              break;
              case '1': 
                vm.validateN11ListeyeEkle=true
                vm.validateN11Gonder=false
              break;
              case '2': 
                vm.validateN11ListeyeEkle=true
                vm.validateN11Gonder=true
              break;
            }

            if (vm.n11SatisFiyati=='0') {
              vm.n11SatisFiyati=vm.dSatisFiyat;
              vm.n11Bilgilendirme='Dikkat! Aşağıdaki alanlar stok kartında getirildi'
            }
            if (vm.n11KategoriId=="") {
              vm.n11Bilgilendirme='Dikkat! Eşleşen Kategori Yok'
              vm.validateN11ListeyeEkle=true
              vm.validateN11Gonder=true
            }
            if (vm.n11PiyasaFiyati=='0') {
              vm.n11PiyasaFiyati=vm.dPiyasaFiyat;
             
            }
            if (vm.n11GonderilecekAdet=='0') {
              vm.n11GonderilecekAdet=vm.dStokAdet;
              
            }
            
            if (vm.veriler[0].alan1!='') {
              vm.validatedAlan1=false
              const ayir=vm.veriler[0].alan1.split('*')
              vm.alan1Ad=ayir[0]
              vm.alan1Deger=ayir[1]
            }

            if (vm.veriler[0].alan2!='') {
              vm.validatedAlan2=false
              const ayir=vm.veriler[0].alan2.split('*')
              vm.alan2Ad=ayir[0]
              vm.alan2Deger=ayir[1]
            }

            if (vm.veriler[0].alan3!='') {
              vm.validatedAlan3=false
              const ayir=vm.veriler[0].alan3.split('*')
              vm.alan3Ad=ayir[0]
              vm.alan3Deger=ayir[1]
            }

            if (vm.veriler[0].alan4!='') {
              vm.validatedAlan4=false
              const ayir=vm.veriler[0].alan4.split('*')
              vm.alan4Ad=ayir[0]
              vm.alan4Deger=ayir[1]
            }

            if (vm.veriler[0].alan5!='') {
              vm.validatedAlan5=false
              const ayir=vm.veriler[0].alan5.split('*')
              vm.alan5Ad=ayir[0]
              vm.alan5Deger=ayir[1]
            }

            if (vm.veriler[0].alan6!='') {
              vm.validatedAlan6=false
              const ayir=vm.veriler[0].alan6.split('*')
              vm.alan6Ad=ayir[0]
              vm.alan6Deger=ayir[1]
            }

            if (vm.veriler[0].alan7!='') {
              vm.validatedAlan7=false
              const ayir=vm.veriler[0].alan7.split('*')
              vm.alan7Ad=ayir[0]
              vm.alan7Deger=ayir[1]
            }

            if (vm.veriler[0].alan8!='') {
              vm.validatedAlan8=false
              const ayir=vm.veriler[0].alan8.split('*')
              vm.alan8Ad=ayir[0]
              vm.alan8Deger=ayir[1]
            }

            if (vm.veriler[0].alan9!='') {
              vm.validatedAlan9=false
              const ayir=vm.veriler[0].alan9.split('*')
              vm.alan9Ad=ayir[0]
              vm.alan9Deger=ayir[1]
            }

            if (vm.veriler[0].alan10!='') {
              vm.validatedAlan10=false
              const ayir=vm.veriler[0].alan10.split('*')
              vm.alan10Ad=ayir[0]
              vm.alan10Deger=ayir[1]
            }
            break;

            case 'Hepsiburada': 
            vm.hepsiburadaKategori=vm.veriler[0].pazaryeriKategori
            vm.hepsiburadaKategoriId=vm.veriler[0].pazaryeriId
            vm.hepsiburadaSatisFiyati=vm.veriler[0].guncelStokFiyat
            vm.hepsiburadaPiyasaFiyati=vm.veriler[0].guncelPiyasaFiyat
            vm.hepsiburadaGonderilecekAdet=vm.veriler[0].gonderilecekAdet
            vm.alan1=vm.veriler[0].alan1
            vm.alan2=vm.veriler[0].alan2
            vm.alan3=vm.veriler[0].alan3
            vm.alan4=vm.veriler[0].alan4
            vm.alan5=vm.veriler[0].alan5
            vm.alan6=vm.veriler[0].alan6
            vm.alan7=vm.veriler[0].alan7
            vm.alan8=vm.veriler[0].alan8
            vm.alan9=vm.veriler[0].alan9
            vm.alan10=vm.veriler[0].alan10
            console.log(vm.veriler[0].marka)
             vm.hepsiBuradaMarka=vm.veriler[0].marka


            vm.hepsiburadaBilgilendirme=''
            switch (vm.veriler[0].durum) {
              case '0': 
                vm.validateHepsiburadaListeyeEkle=false
                vm.validateHepsiburadaGonder=true
              break;
              case '1': 
                vm.validateHepsiburadaListeyeEkle=true
                vm.validateHepsiburadaGonder=false
              break;
              case '2': 
                vm.validateHepsiburadaListeyeEkle=true
                vm.validateHepsiburadaGonder=true
              break;
            }

            if (vm.hepsiburadaSatisFiyati=='0') {
              vm.hepsiburadaSatisFiyati=vm.dSatisFiyat;
              vm.hepsiburadaBilgilendirme='Dikkat! Aşağıdaki alanlar stok kartında getirildi'
            }
            if (vm.hepsiburadaKategoriId=="") {
              vm.hepsiburadaBilgilendirme='Dikkat! Eşleşen Kategori Yok'
              vm.validateHepsiburadaListeyeEkle=true
              vm.validateHepsiburadaGonder=true
            }
            if (vm.hepsiburadaPiyasaFiyati=='0') {
              vm.hepsiburadaPiyasaFiyati=vm.dPiyasaFiyat;
             
            }
            if (vm.hepsiburadaGonderilecekAdet=='0') {
              vm.hepsiburadaGonderilecekAdet=vm.dStokAdet;
              
            }
            
            if (vm.veriler[0].alan1!='') {
              vm.validatedAlan1=false
              const ayir=vm.veriler[0].alan1.split('*')
              vm.alan1Ad=ayir[0]
              vm.alan1Deger=ayir[1]
            }

            if (vm.veriler[0].alan2!='') {
              vm.validatedAlan2=false
              const ayir=vm.veriler[0].alan2.split('*')
              vm.alan2Ad=ayir[0]
              vm.alan2Deger=ayir[1]
            }

            if (vm.veriler[0].alan3!='') {
              vm.validatedAlan3=false
              const ayir=vm.veriler[0].alan3.split('*')
              vm.alan3Ad=ayir[0]
              vm.alan3Deger=ayir[1]
            }

            if (vm.veriler[0].alan4!='') {
              vm.validatedAlan4=false
              const ayir=vm.veriler[0].alan4.split('*')
              vm.alan4Ad=ayir[0]
              vm.alan4Deger=ayir[1]
            }

            if (vm.veriler[0].alan5!='') {
              vm.validatedAlan5=false
              const ayir=vm.veriler[0].alan5.split('*')
              vm.alan5Ad=ayir[0]
              vm.alan5Deger=ayir[1]
            }

            if (vm.veriler[0].alan6!='') {
              vm.validatedAlan6=false
              const ayir=vm.veriler[0].alan6.split('*')
              vm.alan6Ad=ayir[0]
              vm.alan6Deger=ayir[1]
            }

            if (vm.veriler[0].alan7!='') {
              vm.validatedAlan7=false
              const ayir=vm.veriler[0].alan7.split('*')
              vm.alan7Ad=ayir[0]
              vm.alan7Deger=ayir[1]
            }

            if (vm.veriler[0].alan8!='') {
              vm.validatedAlan8=false
              const ayir=vm.veriler[0].alan8.split('*')
              vm.alan8Ad=ayir[0]
              vm.alan8Deger=ayir[1]
            }

            if (vm.veriler[0].alan9!='') {
              vm.validatedAlan9=false
              const ayir=vm.veriler[0].alan9.split('*')
              vm.alan9Ad=ayir[0]
              vm.alan9Deger=ayir[1]
            }

            if (vm.veriler[0].alan10!='') {
              vm.validatedAlan10=false
              const ayir=vm.veriler[0].alan10.split('*')
              vm.alan10Ad=ayir[0]
              vm.alan10Deger=ayir[1]
            }
            break;
            

             case 'Pazarama': 
            vm.pazaramaKategori=vm.veriler[0].pazaryeriKategori
            vm.pazaramaKategoriId=vm.veriler[0].pazaryeriId
            vm.pazaramaSatisFiyati=vm.veriler[0].guncelStokFiyat
            vm.pazaramaPiyasaFiyati=vm.veriler[0].guncelPiyasaFiyat
            vm.pazaramaGonderilecekAdet=vm.veriler[0].gonderilecekAdet
            vm.alan1=vm.veriler[0].alan1
            vm.alan2=vm.veriler[0].alan2
            vm.alan3=vm.veriler[0].alan3
            vm.alan4=vm.veriler[0].alan4
            vm.alan5=vm.veriler[0].alan5
            vm.alan6=vm.veriler[0].alan6
            vm.alan7=vm.veriler[0].alan7
            vm.alan8=vm.veriler[0].alan8
            vm.alan9=vm.veriler[0].alan9
            vm.alan10=vm.veriler[0].alan10
            //console.log(vm.veriler[0].marka)
             vm.pazaramaMarka=vm.veriler[0].marka
             vm.pazaramaMarkaId=vm.veriler[0].ticimaxMarkaId

            vm.pazaramaBilgilendirme=''
            switch (vm.veriler[0].durum) {
              case '0': 
                vm.validatepazaramaListeyeEkle=false
                vm.validatepazaramaGonder=true
              break;
              case '1': 
                vm.validatepazaramaListeyeEkle=true
                vm.validatepazaramaGonder=false
              break;
              case '2': 
                vm.validatepazaramaListeyeEkle=true
                vm.validatepazaramaGonder=true
              break;
            }

            if (vm.pazaramaSatisFiyati=='0') {
              vm.pazaramaSatisFiyati=vm.dSatisFiyat;
              vm.pazaramaBilgilendirme='Dikkat! Aşağıdaki alanlar stok kartında getirildi'
            }
            if (vm.pazaramaKategoriId=="") {
              vm.pazaramaBilgilendirme='Dikkat! Eşleşen Kategori Yok'
              vm.validatepazaramaListeyeEkle=true
              vm.validatepazaramaGonder=true
            }
            if (vm.pazaramaPiyasaFiyati=='0') {
              vm.pazaramaPiyasaFiyati=vm.dPiyasaFiyat;
             
            }
            if (vm.pazaramaGonderilecekAdet=='0') {
              vm.pazaramaGonderilecekAdet=vm.dStokAdet;
              
            }
            
            if (vm.veriler[0].alan1!='') {
              vm.validatedAlan1=false
              const ayir=vm.veriler[0].alan1.split('*')
              vm.alan1Ad=ayir[0]
              vm.alan1Deger=ayir[1]
            }

            if (vm.veriler[0].alan2!='') {
              vm.validatedAlan2=false
              const ayir=vm.veriler[0].alan2.split('*')
              vm.alan2Ad=ayir[0]
              vm.alan2Deger=ayir[1]
            }

            if (vm.veriler[0].alan3!='') {
              vm.validatedAlan3=false
              const ayir=vm.veriler[0].alan3.split('*')
              vm.alan3Ad=ayir[0]
              vm.alan3Deger=ayir[1]
            }

            if (vm.veriler[0].alan4!='') {
              vm.validatedAlan4=false
              const ayir=vm.veriler[0].alan4.split('*')
              vm.alan4Ad=ayir[0]
              vm.alan4Deger=ayir[1]
            }

            if (vm.veriler[0].alan5!='') {
              vm.validatedAlan5=false
              const ayir=vm.veriler[0].alan5.split('*')
              vm.alan5Ad=ayir[0]
              vm.alan5Deger=ayir[1]
            }

            if (vm.veriler[0].alan6!='') {
              vm.validatedAlan6=false
              const ayir=vm.veriler[0].alan6.split('*')
              vm.alan6Ad=ayir[0]
              vm.alan6Deger=ayir[1]
            }

            if (vm.veriler[0].alan7!='') {
              vm.validatedAlan7=false
              const ayir=vm.veriler[0].alan7.split('*')
              vm.alan7Ad=ayir[0]
              vm.alan7Deger=ayir[1]
            }

            if (vm.veriler[0].alan8!='') {
              vm.validatedAlan8=false
              const ayir=vm.veriler[0].alan8.split('*')
              vm.alan8Ad=ayir[0]
              vm.alan8Deger=ayir[1]
            }

            if (vm.veriler[0].alan9!='') {
              vm.validatedAlan9=false
              const ayir=vm.veriler[0].alan9.split('*')
              vm.alan9Ad=ayir[0]
              vm.alan9Deger=ayir[1]
            }

            if (vm.veriler[0].alan10!='') {
              vm.validatedAlan10=false
              const ayir=vm.veriler[0].alan10.split('*')
              vm.alan10Ad=ayir[0]
              vm.alan10Deger=ayir[1]
            }
            break;


            case 'Ticimax': 
            vm.ticimaxKategori=vm.veriler[0].pazaryeriKategori
            vm.ticimaxKategoriId=vm.veriler[0].pazaryeriId
            vm.ticimaxSatisFiyati=vm.veriler[0].guncelStokFiyat
            vm.ticimaxPiyasaFiyati=vm.veriler[0].guncelPiyasaFiyat
            vm.ticimaxGonderilecekAdet=vm.veriler[0].gonderilecekAdet
            vm.alan1=vm.veriler[0].alan1
            vm.alan2=vm.veriler[0].alan2
            vm.alan3=vm.veriler[0].alan3
            vm.alan4=vm.veriler[0].alan4
            vm.alan5=vm.veriler[0].alan5
            vm.alan6=vm.veriler[0].alan6
            vm.alan7=vm.veriler[0].alan7
            vm.alan8=vm.veriler[0].alan8
            vm.alan9=vm.veriler[0].alan9
            vm.alan10=vm.veriler[0].alan10
            vm.ticimaxMarkaId=vm.veriler[0].ticimaxMarkaId
            vm.hepsiBuradaMarka=vm.veriler[0].marka

            vm.ticimaxBilgilendirme=''
            switch (vm.veriler[0].durum) {
              case '0': 
                vm.validateTicimaxListeyeEkle=false
                vm.validateTicimaxGonder=true
              break;
              case '1': 
                vm.validateTicimaxListeyeEkle=true
                vm.validateTicimaxGonder=false
              break;
              case '2': 
                vm.validateTicimaxListeyeEkle=true
                vm.validateTicimaxGonder=true
              break;
            }

            if (vm.ticimaxSatisFiyati=='0') {
              vm.ticimaxSatisFiyati=vm.dSatisFiyat;
              vm.ticimaxBilgilendirme='Dikkat! Aşağıdaki alanlar stok kartında getirildi'
            }
            if (vm.ticimaxKategoriId=="") {
              vm.ticimaxBilgilendirme='Dikkat! Eşleşen Kategori Yok'
              vm.validateTicimaxListeyeEkle=true
              vm.validateTicimaxGonder=true
            }
            if (vm.ticimaxPiyasaFiyati=='0') {
              vm.ticimaxPiyasaFiyati=vm.dPiyasaFiyat;
             
            }
            if (vm.ticimaxGonderilecekAdet=='0') {
              vm.ticimaxGonderilecekAdet=vm.dStokAdet;
              
            }
            
            if (vm.veriler[0].alan1!='') {
              vm.validatedAlan1=false
              const ayir=vm.veriler[0].alan1.split('*')
              vm.alan1Ad=ayir[0]
              vm.alan1Deger=ayir[1]
            }

            if (vm.veriler[0].alan2!='') {
              vm.validatedAlan2=false
              const ayir=vm.veriler[0].alan2.split('*')
              vm.alan2Ad=ayir[0]
              vm.alan2Deger=ayir[1]
            }

            if (vm.veriler[0].alan3!='') {
              vm.validatedAlan3=false
              const ayir=vm.veriler[0].alan3.split('*')
              vm.alan3Ad=ayir[0]
              vm.alan3Deger=ayir[1]
            }

            if (vm.veriler[0].alan4!='') {
              vm.validatedAlan4=false
              const ayir=vm.veriler[0].alan4.split('*')
              vm.alan4Ad=ayir[0]
              vm.alan4Deger=ayir[1]
            }

            if (vm.veriler[0].alan5!='') {
              vm.validatedAlan5=false
              const ayir=vm.veriler[0].alan5.split('*')
              vm.alan5Ad=ayir[0]
              vm.alan5Deger=ayir[1]
            }

            if (vm.veriler[0].alan6!='') {
              vm.validatedAlan6=false
              const ayir=vm.veriler[0].alan6.split('*')
              vm.alan6Ad=ayir[0]
              vm.alan6Deger=ayir[1]
            }

            if (vm.veriler[0].alan7!='') {
              vm.validatedAlan7=false
              const ayir=vm.veriler[0].alan7.split('*')
              vm.alan7Ad=ayir[0]
              vm.alan7Deger=ayir[1]
            }

            if (vm.veriler[0].alan8!='') {
              vm.validatedAlan8=false
              const ayir=vm.veriler[0].alan8.split('*')
              vm.alan8Ad=ayir[0]
              vm.alan8Deger=ayir[1]
            }

            if (vm.veriler[0].alan9!='') {
              vm.validatedAlan9=false
              const ayir=vm.veriler[0].alan9.split('*')
              vm.alan9Ad=ayir[0]
              vm.alan9Deger=ayir[1]
            }

            if (vm.veriler[0].alan10!='') {
              vm.validatedAlan10=false
              const ayir=vm.veriler[0].alan10.split('*')
              vm.alan10Ad=ayir[0]
              vm.alan10Deger=ayir[1]
            }
            break;
          }
          } else {
             vm.trendyolBilgilendirme=''
              vm.trendyolBilgilendirme='Eşleşen Kategori Bulunamadı'
              vm.n11Bilgilendirme=''
              vm.n11Bilgilendirme='Eşleşen Kategori Bulunamadı'
              vm.hepsiburadaBilgilendirme=''
              vm.hepsiburadaBilgilendirme='Eşleşen Kategori Bulunamadı'
              vm.ticimaxBilgilendirme=''
              vm.ticimaxBilgilendirme='Eşleşen Kategori Bulunamadı'
          }
      })
      })
    },
    stokListesi() {

      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {token:Store.state.tokenId,kod:vm.barkod}
      soap.createClient(url, function(err, client){
      client.stokListesi(args, function(err, result){
        if (result.stokListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

       vm.veriler=JSON.parse(result.stokListesiResult)
       vm.liste=vm.veriler 
      })
     
      })


    },
    kartDetay(kod) {

 this.dStokAdi=''
      this.dStokKodu=''
      this.dBarkod=''
      this.dRenk=''
      this.dBeden=''
      this.dDigerOzellikler=''
      this.dKategori=''
      this.dSatisFiyat=0
      this.dPiyasaFiyat=0
      this.dStokAdet=0
      this.dKdv=0
      this.trendyolKategori=''
      this.trendyolKategoriId=0
      this.trendyolSatisFiyati=0
      this.trendyolPiyasaFiyati=0
      this.trendyolGonderilecekAdet=0
      this.trendyolBilgilendirme=''
      this.n11Kategori=''
      this.n11KategoriId=0
      this.n11SatisFiyati=0
      this.n11PiyasaFiyati=0
      this.n11GonderilecekAdet=0
      this.n11Bilgilendirme=''
      this.hepsiburadaKategori=''
      this.hepsiburadaKategoriId=0
      this.hepsiburadaSatisFiyati=0
      this.hepsiburadaPiyasaFiyati=0
      this.hepsiburadaGonderilecekAdet=0
      this.hepsiburadaBilgilendirme=''
      this.ticimaxKategori=''
      this.ticimaxKategoriId=0
      this.ticimaxSatisFiyati=0
      this.ticimaxPiyasaFiyati=0
      this.ticimaxGonderilecekAdet=0
      this.ticimaxBilgilendirme=''
      this.alan1=''
      this.alan2=''
      this.alan3=''
      this.alan4=''
      this.alan5=''
      this.alan6=''
      this.alan7=''
      this.alan8=''
      this.alan9=''
      this.alan10=''
      this.validatedAlan1=true
      this.validatedAlan2=true
      this.validatedAlan3=true
      this.validatedAlan4=true
      this.validatedAlan5=true
      this.validatedAlan6=true
      this.validatedAlan7=true
      this.validatedAlan8=true
      this.validatedAlan9=true
      this.validatedAlan10=true
      this.alan1Ad=''
      this.alan2Ad=''
      this.alan3Ad=''
      this.alan4Ad=''
      this.alan5Ad=''
      this.alan6Ad=''
      this.alan7Ad=''
      this.alan8Ad=''
      this.alan9Ad=''
      this.alan10Ad=''
      this.alan1Deger=''
      this.alan2Deger=''
      this.alan3Deger=''
      this.alan4Deger=''
      this.alan5Deger=''
      this.alan6Deger=''
      this.alan7Deger=''
      this.alan8Deger=''
      this.alan9Deger=''
      this.alan10Deger=''
      this.stokAciklama=''
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress

      const args = {token:Store.state.tokenId,kod:kod}
      soap.createClient(url, function(err, client){
      client.stokListesi(args, function(err, result){
        if (result.stokListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

       vm.verilerDetay=JSON.parse(result.stokListesiResult)
      // console.log(vm.verilerDetay)
       vm.dStokAdi=vm.verilerDetay[0].StokAdi
       vm.dStokKodu=vm.verilerDetay[0].stokKodu
       vm.dBarkod=vm.verilerDetay[0].Barkod
       //vm.dDetay=vm.veriler[0].detay
       vm.dRenk=vm.verilerDetay[0].renk
       vm.dBeden=vm.verilerDetay[0].beden
       vm.dKategori=vm.verilerDetay[0].kategori1+' -> '+vm.verilerDetay[0].kategori2+' ->'+vm.verilerDetay[0].kategori3
        vm.dSatisFiyat=vm.verilerDetay[0].SATIS_FIAT1;
        vm.dPiyasaFiyat=vm.verilerDetay[0].LISTE_FIAT;
        vm.dStokAdet=vm.verilerDetay[0].stokAdet;
        vm.dKdv=vm.verilerDetay[0].kdv;
        if (vm.verilerDetay[0].gonderilenDetay!='') {
          vm.stokAciklama=vm.verilerDetay[0].gonderilenDetay;
        } else {
          vm.stokAciklama=vm.verilerDetay[0].detay;
        }
        
        
       vm.dDigerOzellikler=''
       if (vm.verilerDetay[0].alan1!="" && vm.verilerDetay[0].alan1!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.veriler[0].alan1+","
       }
       if (vm.verilerDetay[0].alan2!="" && vm.verilerDetay[0].alan2!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan2+","
       }
       if (vm.verilerDetay[0].alan3!="" && vm.verilerDetay[0].alan3!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan3+","
       }
       if (vm.verilerDetay[0].alan4!="" && vm.verilerDetay[0].alan4!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan4+","
       }
       if (vm.verilerDetay[0].alan5!="" && vm.verilerDetay[0].alan5!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan5+","
       }
       if (vm.verilerDetay[0].alan6!="" && vm.verilerDetay[0].alan6!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan6+","
       }
       if (vm.verilerDetay[0].alan7!="" && vm.verilerDetay[0].alan7!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan7+","
       }
       if (vm.verilerDetay[0].alan8!="" && vm.verilerDetay[0].alan8!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan8+","
       }
       if (vm.verilerDetay[0].alan9!="" && vm.verilerDetay[0].alan9!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan9+","
       }
       if (vm.verilerDetay[0].alan10!="" && vm.verilerDetay[0].alan10!="null") {
         vm.dDigerOzellikler=vm.dDigerOzellikler+vm.verilerDetay[0].alan10+","
       }

      vm.popupKartDetay=true

      })
     
      })


        
    },
    ticimaxGonder() {

           // this.popupGonderilenStokListesi=true
         var vm = this
var vs = this.$vs
    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Ticimax',token:Store.state.tokenId,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.StokAktar(args, function(err, result){
        if (result.StokAktarResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        console.log(result.StokAktarResult)
        vm.veriler=JSON.parse(result.StokAktarResult)
        if (vm.veriler.response=="Ok") {
          vs.notify({
                title: 'Ticimax Gönderim',
                text: "Ürün Ticimax Gönderildi",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success',
                position:'top-center'
              })
        }
       // vm.eslesenStokListesi=vm.veriler
        //console.log(vm.veriler.batchRequestId)
        
         setTimeout(function() {
        // vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  

       
        
      })
      })


    },

    pazaramaGonder() {

           // this.popupGonderilenStokListesi=true
         var vm = this
var vs = this.$vs
    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {program:'Pazarama',token:Store.state.tokenId,barkod:this.dBarkod}
      soap.createClient(url, function(err, client){
      client.StokAktar(args, function(err, result){
        if (result.StokAktarResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        console.log(result.StokAktarResult)
        vm.veriler=JSON.parse(result.StokAktarResult)
        if (vm.veriler.response=="Ok") {
          vs.notify({
                title: 'Pazarama Gönderim',
                text: "Ürün Pazarama Gönderildi",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success',
                position:'top-center'
              })
        }
       // vm.eslesenStokListesi=vm.veriler
        //console.log(vm.veriler.batchRequestId)
        
         setTimeout(function() {
        // vm.trendyolAktarumDurum(vm.veriler.batchRequestId)
    }, 2500)  

       
        
      })
      })


    },

  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        
      },
      deep: true
    }
  },beforeMount(){
     this.stokListesi()
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
